import { type InferResponseType, unwrap } from "@nexxt/api-client";
import { queryOptions } from "@tanstack/react-query";
import { api } from "../../api";

// Server state of the approval gates (50-api/reference.md): all of them at once, with the roles one can be given.

const gates = api.reference.gates;

type Gates = InferResponseType<typeof gates.$get, 200>;
export type Gate = Gates["items"][number];
export type GateRole = Gates["roles"][number];

const keys = { all: ["gates"] as const };

export const gateQueries = {
  ...keys,

  list: () =>
    queryOptions({
      queryKey: [...keys.all, "list"],
      queryFn: ({ signal }) => unwrap(gates.$get({}, { init: { signal } })),
    }),
};
